import { Link } from 'react-router-dom';
import { ArrowIcon, Seo, SiteHeader } from '../components/shared';

export default function ErrorPage() {
  return (
    <div className="page">
      <Seo />
      <SiteHeader>
        <Link to="/students" className="nav-link">For students</Link>
        <Link to="/home-owners" className="nav-link">For home owners</Link>
      </SiteHeader>
      <main className="error-page">
        <h2 className="h2">Oops! You've encountered an error.</h2>
        <p>Please return to the home page.</p>
        <Link to="/" className="btn btn--primary btn--md">Go home <ArrowIcon size={17} /></Link>
      </main>
    </div>
  );
}
